// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__K89YL","contentWrap":"styles_contentWrap__rkxHi","cardContentWrap":"styles_cardContentWrap__FRRl7","cardColumnWrap":"styles_cardColumnWrap__g+Yqk"};